import React from "react";
import { createRoot } from 'react-dom/client';
import { WidgetNiort } from "./components/WidgetNiort";

export const mount = (props) => {
    const container = document.getElementById(props.containerId)
    const root = createRoot(container);
    return root.render(<WidgetNiort {...props} />);
}